// nav-dropdown-columns.js

/**
 * AUTO-APPLY TWO-COLUMN LAYOUT FOR LARGE DROPDOWNS
 * ------------------------------------------------
 * On DOM ready, finds all <ul class="dropdown"> elements with more than 16 <li>s.
 * Adds "two-column" class if CSS columns are supported.
 */
$(function() {
  if (
    'WebkitColumnCount' in document.body.style ||
    'MozColumnCount' in document.body.style ||
    'OColumnCount' in document.body.style ||
    'MsColumnCount' in document.body.style ||
    'columnCount' in document.body.style
  ) {
    $('ul.dropdown').filter(function() {
      return $(this).find('li').length > 16;
    }).addClass('two-column');
  }
});
